module.exports = function(ads) {
	'use strict'
	ads.directive('adsCategoryAccordion',adsCategoryAccordion);
	adsCategoryAccordion.$inject=['$timeout','refreshtokenService','alertService','serverError','config','postDataService','getDataService','jQuery'];
	function adsCategoryAccordion($timeout, refreshtokenService, alertService,serverError, config, postDataService, getDataService, jQuery) {
		return {
			restrict: 'E',
			scope:{
				categories:'=',
				open:'=',
				removeItem: '='
			},
			replace:true,
			template: require('./partial/adsCategoryAccordion.html'),
			link: function(scope, ele, $attrs, ctrl) {
				// Add the hasCheckedDescendant function
				scope.hasCheckedDescendant = function(category) {
					if (!category.children || category.children.length === 0) {
						return false;
					}
					
					// Check direct children
					for (var i = 0; i < category.children.length; i++) {
						if (category.children[i].checked) {
							return true;
						}
						
						// Check descendants recursively
						if (hasDescendantsChecked(category.children[i])) {
							return true;
						}
					}
					
					return false;
				};
				
				// Helper function to check descendants recursively
				function hasDescendantsChecked(cat) {
					if (!cat.children || cat.children.length === 0) {
						return false;
					}
					
					for (var i = 0; i < cat.children.length; i++) {
						if (cat.children[i].checked) {
							return true;
						}
						
						if (hasDescendantsChecked(cat.children[i])) {
							return true;
						}
					}
					
					return false;
				}
				
				// Only watch categories at the current level - not their children
				// Child categories will be watched by their own directive instances
				if (scope.categories && scope.categories.length) {
					angular.forEach(scope.categories, function(category) {
						// Watch only this category's checked property (not its children)
						scope.$watch(function() { 
							return category.checked; 
						}, function() {
							// Empty callback is sufficient
							// The digest cycle will update the UI
						});
					});
				}
				
				// Also watch for array changes to detect new categories at this level
				scope.$watchCollection('categories', function() {
					// This will re-evaluate hasCheckedDescendant whenever
					// the categories array changes at this level
				});
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/adsModule/settings/js/directive/adsCategoryAccordionDirective.js
// module id = 483
// module chunks = 0